<script lang="tsx">
import type { UnwrapNestedRefs } from "vue";
import type { Option } from 'element-plus/lib/components/select-v2/src/select.types'
import type {
  PowerfulBtnPropsType,
} from 'quick-vue-components/PowerfulBtn/src/index'
import type { BtnStateType } from 'quick-vue-components/PowerfulBtn/src/types'
import type { QuickFormPropsType } from 'quick-vue-components/QuickForm/src'
import type {
  FormRenderItemConfType,
  QuickFormType,
} from 'quick-vue-components/QuickForm/src/types'
import { $t } from "@user-center/utils/i18n.ts";
import type { ComponentPublicInstance } from "vue";
import type { ExtractPropTypes, PropType, SetupContext, VNode } from "vue";
import type {
  EditFormType, OnDataChangeInterface, RenderDataMapInterface, RuleFormRenderDataFilterInterface, RuleLabelFilterInterface, SetAddRuleFormInitValueFilterInterface, SetEditRuleFormValueFilterInterface, SetLabelDataType, WeightRule, WeightRuleTreeNode, } from './type'

import Bus from '@user-center/bus'
import { getLabel } from '@user-center/utils'
import {
  ArrowDown, ArrowLeft, ArrowRight, Delete, DocumentCopy, Edit, Place, Plus, Remove, } from '@element-plus/icons-vue'
import { ElMessage, ElPopover, ElTableColumn } from "element-plus";
import lodash, { cloneDeep, isArray, isFunction, merge } from 'lodash-es'

import PowerfulBtn from 'quick-vue-components/PowerfulBtn/src/index'
import { buildProps } from 'quick-vue-components/utils/props'
import {
  defineComponent,
  getCurrentInstance,
  h,
  nextTick,
  onBeforeMount,
  reactive,
  watch,
} from 'vue'
const renderDataMap: RenderDataMapInterface = {
  unitMap: {
    'ruleType-0': 'kg',
    'ruleType-8': 'kg',
    'ruleType-1': 'kg',
    'ruleType-2': $t('unit.piece'),
    'ruleType-3': $t('unit.piece'),
    'ruleType-9': '¥',
    'ruleType-10': '¥',
    'ruleType-11': 'cm³',
    'ruleType-12': 'cm',
  },
  ruleType: {
    type: 'select',
    name: 'ruleType',
    style: 'width:100%',
    options: [
      {
        label:  $t('text.packageWeight'),
        value: '0',
      },
      {
        label: $t('text.feeWeight'), 
        value: '8',
      },
      {
        label:$t('text.monthAverageWeight'),
        value: '1',
      },
      {
        label: $t('text.monthSendAmount'),
        value: '2',
      },
      {
        label:  $t('text.daySendAmount'),
        value: '3',
      },
      {
        label:$t('text.mountTransportFeeAmount'),
        value: '9',
      },
      {
        label:$t('text.safePriceAmount'),
        value: '10',
      },
      { label:$t('text.volume'), value: '11' },
      { label: $t('text.packageLength'),value: '12' },
    ],
    layoutCol: { sm: 24 },
    label: $t('text.规则类型'),
    rules: [{ required: true, message: $t('placeholder.pleaseSelect',{text:$t('text.规则类型')})}],
  },

  startInterval: {
    type: 'select',
    name: 'startInterval',
    style: 'width:100%',
    layoutCol: { sm: 4 },
    options: [
      { label:$t('text.greater'), value: '0' },
      { label:$t('text.greaterAndEqual'), value: '1' },
    ],
    formItemProps: { labelWidth: '0px' },
    clearable: false,
    label: '',
    rules: [{ required: true, message:$t('placeholder.pleaseSelect',{text:''}) }],
  },
  endInterval: {
    type: 'select',
    name: 'endInterval',
    style: 'width:100%',
    layoutCol: { sm: 4 },
    options: [
      { label: $t('text.less'), value: '0' },
      { label:$t('text.lessAndEqual') , value: '1' },
    ],
    clearable: false,
    formItemProps: { labelWidth: '0px' },
    label: '',
    rules: [{ required: true, message: $t('placeholder.pleaseSelect',{text:''}) }],
  },
  minWeight: {
    type: 'number',
    name: 'minWeight',
    //  min: 0,
    style: 'width:100%',
    layoutCol: { sm: 8 },
    formItemProps: { labelWidth: '0px' },
    label: '',
    rules: [{ required: true, message: $t('placeholder.pleaseInput',{text:''})  }],
  },
  maxWeight: {
    type: 'number',
    name: 'maxWeight',
    style: 'width:100%',
    //   min: 0,
    layoutCol: { sm: 8 },
    label: '',
    formItemProps: { labelWidth: '0px' },
    rules: [{ required: true, message: $t('placeholder.pleaseInput',{text:''}) }],
  },

  price: {
    type: 'number',
    style: 'width:100%',
    name: 'price',
    min: 0,
    layoutCol: { sm: 12 },
    label: '价格',
  },
  priceType: {
    type: 'select',
    style: 'width:100%',
    name: 'priceType',
    options: [
      {
        label: $t('text.perKg'),
        value: '0',
      },
      {
        label:$t('text.onePrice'), 
        value: '1',
      },
      {
        label: $t('text.per0_1Kg'),
        value: '2',
      },
      {
        label: $t('text.per0_5Kg'),
        value: '3',
      },
      { label:$t('text.perCubicMeter'), value: '20' },
    ],
    layoutCol: { sm: 12 },
    label: $t('text.priceType'),
  },
}

export const RateTableProps = buildProps({
  showZeroPrice: {
    // 是否显示0价格
    type: Boolean,
    default: false,
  },
  ruleTypeDisabled: {
    // 规则类型是否固定不可更改
    type: Boolean,
    default: false,
  },
  buttonGroupWidth: {
    // 每行编辑按钮宽度
    type: String,
    default: '150px',
  },
  ruleType: {
    // 保留属性
    type: String,
    default: '',
  },
  config: {
    // 全部配置对应 renderDataMap
    type: Object as PropType<Partial<RenderDataMapInterface>>,
    default: (): RenderDataMapInterface => cloneDeep(renderDataMap),
  },

  onDataChange: {
    // 当数据改变时回调方法
    type: Function as PropType<OnDataChangeInterface>,
    default: (d: WeightRule[]): void => {
      console.log(d)
    },
  },

  disabled: {
    // 是否禁用
    type: Boolean,
    default: false,
  },
  ruleLabelFilter: {
    // 显示表头过滤方法
    type: [Function as PropType<RuleLabelFilterInterface>, Boolean],
    default: false,
  },
  setAddRuleFormInitValueFilter: {
    // 设置新增初始值
    type: Function as PropType<SetAddRuleFormInitValueFilterInterface>,
    default: (res: WeightRule, _conf: EditFormType): WeightRule => res,
  },
  setEditRuleFormValueFilter: {
    // 设置新增初始值
    type: Function as PropType<SetEditRuleFormValueFilterInterface>,
    default: (res: WeightRule, _conf: EditFormType): WeightRule => res,
  },
  modelValue: {
    // 组件的值
    type: Array as PropType<WeightRule[]>,
    default: (): WeightRule[] => [],
  },
  ruleFormRenderDataFilter: {
    // 每次弹出表单时表单界面的渲染方法
    type: Function as PropType<RuleFormRenderDataFilterInterface>,
    default: (
      resRenderData: FormRenderItemConfType<any>[],
      _conf: EditFormType,
      _ctx: any,
      _formObj: QuickFormType,
    ): FormRenderItemConfType<any>[] => resRenderData,
  },
})

export type RateTablePropsType = ExtractPropTypes<typeof RateTableProps>
export interface DataStateType {
  tableRenderKey: number
  renderDataMap: RenderDataMapInterface
  weightRule: WeightRule[]
}
export interface RateTableType {
  dataState: UnwrapNestedRefs<DataStateType>
  initWeightRuleData: (setData: Partial<WeightRule>) => WeightRule
  treeTableColRender: (
    list: WeightRule[],
    parent: WeightRule | null,
    lvKeys: number[]
  ) => VNode[]
  setAddRuleFormInitValue: (
    nowRules: WeightRule[],
    conf: EditFormType
  ) => WeightRule
  getWeightRuleFormAttrs: (conf: EditFormType) => Partial<QuickFormPropsType>
  updateSort: (weightRules: WeightRule[]) => void
}
export default defineComponent({
  name: 'RateTable',
  components: {
    Delete,
    Remove,
    ArrowLeft,
    ArrowRight,
    DocumentCopy,
  },

  props: RateTableProps,
  setup(props: RateTablePropsType, ctx: SetupContext<any>): RateTableType {
    const refs: {
      table: any
    } = {
      table: null,
    }
    const nowInstance: any = getCurrentInstance()
    const that: any = nowInstance.ctx
    const dataState: UnwrapNestedRefs<DataStateType> = reactive({
      tableRenderKey: 10,
      weightRule: props.modelValue ? cloneDeep(props.modelValue) : [],
      renderDataMap: cloneDeep(renderDataMap),
    })
    watch(
      () => dataState.weightRule,
      (newVal) => {
        ctx.emit('update:modelValue', newVal)
      },
    )
    watch(
      () => props.modelValue,
      (newVal: WeightRule[]) => {
        dataState.weightRule = newVal
      },
    )

    onBeforeMount(() => {
      Bus.$on('baseRateTableUpdateRender', () => {
        dataState.tableRenderKey = new Date().valueOf()
      })
      initConfig()
    })
    /**
     * @description 初始化配置
     * @param {any} list
     * @param {any} i
     * @returns {any}
     */
    function initConfig(): void {
      dataState.renderDataMap = props.config.reset
        ? JSON.parse(JSON.stringify(props.config))
        : merge(renderDataMap, props.config)
    }

    /**
     * @description 判断是否首续重
     * @param {any} list
     * @param {any} i
     * @returns {any}
     */
    function isFirstOnePrice(list: WeightRule[], i: number): boolean {
      let x = -1
      list.map((o: WeightRule, y: number) => {
        if (o.priceType == '1' && x < 0) {
          x = y
        }
      })
      return i <= x
    }

    /**
     * @description  显示表头文字
     * @param {any} rule
     * @param {any} i
     * @param {any} list
     * @param {boolean} isGetObject  是否返回对象
     * @returns {any}
     */
    function setLabel(
      rule: WeightRule,
      i: number,
      list: WeightRule[],
      isGetObject: boolean,
    ): SetLabelDataType | string {
      const setRuleText: string
        = rule.ruleType && dataState.renderDataMap.ruleType
          ? getLabel(dataState.renderDataMap.ruleType.options, rule.ruleType)
          : ''
      const unit: string = dataState.renderDataMap.unitMap
        ? dataState.renderDataMap.unitMap[`ruleType-${rule.ruleType}`]
        : ''
      const minWeight: number
        = dataState.renderDataMap.minWeight
        && dataState.renderDataMap.minWeight.name
          ? rule[dataState.renderDataMap.minWeight.name]
          : 0
      const maxWeight: number
        = dataState.renderDataMap.maxWeight
        && dataState.renderDataMap.maxWeight.name
          ? rule[dataState.renderDataMap.maxWeight.name]
          : 0
      const priceTypeLabel: string = dataState.renderDataMap.priceType
        ? getLabel(dataState.renderDataMap.priceType.options, rule.priceType)
        : ''
      /*  判断是否首续重
      if (rule.parentRuleType == "0" && rule.ruleType == "0") {
        if (rule.priceType == "1" && this.isFirstOnePrice(list, i)) {
          priceTypeLabel = "首重价格";
        } else {
          priceTypeLabel = "续重" + priceTypeLabel;
        }
      } */
      const setObject: SetLabelDataType = {
        minWeight,
        maxWeight,
        unit,
        setRuleText,
        rule,
        priceTypeLabel,
      }
      const startSymbol = rule.startInterval == '1' ? '<=' : '<'
      const endSymbol = rule.endInterval == '0' ? '<' : '<='
      if (isFunction(props.ruleLabelFilter)) {
        return props.ruleLabelFilter(setObject)
      }

      return isGetObject
        ? setObject
        : ` ${minWeight}${unit}${startSymbol} ${setRuleText} 
        ${maxWeight ? endSymbol + (maxWeight || '') + unit : ''} 
      ${rule.price ? `,${priceTypeLabel}` : ''}`
    }

    function initWeightRuleData(setData: Partial<WeightRule>): WeightRule {
      return {
        ruleType: '0',
        minWeight: 0,
        maxWeight: 0,

        priceType: '1',
        price: 0,

        parentRuleType: '',
        childRule: [],
        stencilIdList: [],
        stencilId: '',
        sort: -1,
        ...setData,
      }
    }
    /**
     * @description
     * @param {any} nowRules
     * @returns {any}
     */
    function setAddRuleFormInitValue(
      nowRules: WeightRule[],
      conf: EditFormType,
    ): WeightRule {
      const res: WeightRule = initWeightRuleData({
        ruleType: '0',
        startInterval: '0',
        endInterval: '1',
      })

      return props.setAddRuleFormInitValueFilter(res, conf)
    }
    /**
     * @description 根据数组下标筛选值
     * @param {Array} idxArr demo:[1,3,3]
     * @returns {any}
     */
    function findItemByidxArr(idxArr: number[]): WeightRule | WeightRule[] {
      let v: WeightRule[] | WeightRule = dataState.weightRule
      if (idxArr) {
        // 暂时重新通过下标获取数据，后期再优化

        idxArr.map((index: number, len: number) => {
          if (len + 1 == idxArr.length) {
            v = v[index]
          }
          else {
            v = v[index].childRule
          }
        })
      }

      return v
    }

    /**
     * @description
     * @param {any} idxArr
     * @returns {any}
     */
    function rowToEditFormValue(
      idxArr: number[],
      conf: EditFormType,
    ): WeightRule {
      const cloneItem: WeightRule | WeightRule[] = cloneDeep(
        findItemByidxArr(idxArr),
      )
      const setItem: WeightRule = !isArray(cloneItem)
        ? cloneItem
        : cloneItem[0]

      if (typeof setItem.startInterval == 'undefined') {
        setItem.startInterval = '0'
      }
      if (typeof setItem.endInterval == 'undefined') {
        setItem.endInterval = '1'
      }

      return props.setEditRuleFormValueFilter(setItem, conf)
    }

    /**
     * @description
     * @param {any} idxArr
     * @param {any} objIdx
     * @param {any} moveLen
     */
    function moveRule(idxArr: number[], objIdx: number, moveLen: number): void {
      const findItem: WeightRule | WeightRule[] = findItemByidxArr(idxArr)
      const setItem: WeightRule[] = isArray(findItem)
        ? findItem
        : findItem.childRule || []
      const moveItem = setItem[objIdx]
      const setMoveItem = setItem[objIdx + moveLen]
      if (setMoveItem) {
        setItem[objIdx + moveLen] = moveItem
        setItem[objIdx] = setMoveItem
      }
      else {
        ElMessage({
          message: `区间规则已经为${moveLen > 0 ? '末位' : '首位'}`,
          type: 'warning',
        })
      }
      Bus.$emit('baseRateTableUpdateRender')
      // that.$forceUpdate && that.$forceUpdate();
      updateSort(dataState.weightRule)
      props.onDataChange(dataState.weightRule)
      ctx.emit('update:modelValue', dataState.weightRule)
    }

    /**
     * @description  复制一个区间
     * @param {any} idxArr
     * @param {any} objIdx
     */
    function copyRuleRow(idxArr: number[], objIdx: number): void {
      const findItem: WeightRule | WeightRule[] = findItemByidxArr(idxArr)
      const setListItem: WeightRule[] = isArray(findItem)
        ? findItem
        : findItem.childRule || []

      const copyItem: WeightRule = cloneDeep(setListItem[objIdx])

      setListItem.splice(objIdx + 1, 0, copyItem)
      Bus.$emit('baseRateTableUpdateRender')
      //  that.$forceUpdate && that.$forceUpdate();
      updateSort(dataState.weightRule)
      props.onDataChange(dataState.weightRule)
      ctx.emit('update:modelValue', dataState.weightRule)
    }

    /**
     * @description
     * @param {any} idxArr
     * @param {any} objIdx
     */
    function deleteRuleRow(idxArr: number[], objIdx: number): void {
      const findItem: WeightRule | WeightRule[] = findItemByidxArr(idxArr)
      if (lodash.isArray(findItem)) {
        findItem.splice(objIdx, 1)
      }
      else if (findItem.childRule) {
        findItem.childRule.splice(objIdx, 1)
      }
      Bus.$emit('baseRateTableUpdateRender')
      // that.$forceUpdate && that.$forceUpdate();
      nextTick(() => {
        refs.table && refs.table.doLayout && refs.table.doLayout() // 删除后排版错位
      })
      updateSort(dataState.weightRule)
      props.onDataChange(dataState.weightRule)
      ctx.emit('update:modelValue', dataState.weightRule)
    }

    /**
     * @description
     * @param {any} idxArr
     * @param {any} objIdx
     * @returns {any}
     */
    function deleteNowRuleRow(idxArr: number[], objIdx: number): void {
      const findItem: WeightRule | WeightRule[] = findItemByidxArr(idxArr)
      let findItems: WeightRule[] = []
      const isItemArray: boolean = lodash.isArray(findItem)
      const setItem: WeightRule = isItemArray ? findItem[0] : findItem
      if (isItemArray) {
        findItems = findItem as WeightRule[]
      }
      const changeParentRuleType: string | undefined = setItem.parentRuleType
        ? setItem.parentRuleType
        : undefined
      const deleteList: WeightRule[] = isItemArray
        ? (findItem as WeightRule[])
        : (findItem as WeightRule).childRule || []
      const weightRules: WeightRule[]
        = deleteList[objIdx].childRule
        && (deleteList[objIdx].childRule as WeightRule[]).length
          ? cloneDeep(deleteList[objIdx].childRule as WeightRule[])
          : []
      weightRules.map((o: WeightRule) => {
        o.parentRuleType = changeParentRuleType || ''
        return o
      })
      deleteList.splice(objIdx, 1, ...weightRules)
      Bus.$emit('baseRateTableUpdateRender')
      //  that.$forceUpdate && that.$forceUpdate();
      nextTick(() => {
        refs.table && refs.table.doLayout && refs.table.doLayout() // 删除后排版错位
      })
      updateSort(dataState.weightRule)
      props.onDataChange(dataState.weightRule)
      ctx.emit('update:modelValue', dataState.weightRule)
    }

    /**
     * @description
     * @param {any} val
     * @param {any} conf
     * @returns {any}
     */
    function filterSubmitData(val: WeightRule, conf: EditFormType): WeightRule {
      const setData: WeightRule = cloneDeep(val)
      setData.parentRuleType = conf.parentObj ? conf.parentObj.ruleType : ''
      if (!setData.childRule) {
        setData.childRule = []
      }
      else {
        setData.childRule.map((o: WeightRule) => {
          o.parentRuleType = val.ruleType || ''
          return o
        })
      }

      return setData
    }
    /**
     * @description  新增规则区间方法
     * @param {any} conf   {type: "editRule", obj: obj, parentObj: parent, idx: [...lvKeys, i],  parentIdx: lvKeys}
     * @returns {any}
     */
    function addRuleFunc(conf: EditFormType, setVal: WeightRule): void {
      if (conf.isUpParent) {
        console.log('isUpParent')
      }
      else {
        // 新增
        if (!conf.parentObj) {
          // 顶级
          dataState.weightRule.push(setVal)
        }
        else {
          const findItem: WeightRule | WeightRule[] = findItemByidxArr(
            conf.idx,
          )
          if (isArray(findItem)) {
            findItem.push(setVal)
          }
          else {
            if (!findItem.childRule) {
              findItem.childRule = []
            }
            findItem.childRule.push(setVal)
          }
        }
      }
    }
    /**
     * @description  移动规则区间方法
     * @param {any} conf   {type: "editRule", obj: obj, parentObj: parent, idx: [...lvKeys, i],  parentIdx: lvKeys}
     * @returns {any}
     */
    function moveRuleFunc(conf: EditFormType, v: WeightRule): void {
      const findItem = cloneDeep(findItemByidxArr(conf.idx)) as WeightRule
      const findParentItem: WeightRule
        = conf.idx.length > 1
          ? (findItemByidxArr(conf.parentIdx) as WeightRule)
          : initWeightRuleData({ childRule: dataState.weightRule })

      const setParnetItem: WeightRule
        = v.treeIndex == 'top'
          ? initWeightRuleData({ childRule: dataState.weightRule })
          : (findItemByidxArr(
              v.treeIndex
                ? v.treeIndex.split('-').map((o: string) => Number(o))
                : [],
            ) as WeightRule)
      // 标记烂代码
      findItem.sort = setParnetItem.childRule
        ? setParnetItem.childRule.length
        : 0
      findItem.parentRuleType = setParnetItem.ruleType

      if (!setParnetItem.childRule || setParnetItem.price) {
        setParnetItem.childRule = []
        setParnetItem.price = 0
        setParnetItem.priceType = ''
      }

      setParnetItem.childRule.push(findItem)
      if (!findParentItem.childRule) {
        findParentItem.childRule = []
      }
      findParentItem.childRule.splice(conf.idx[conf.idx.length - 1], 1)
    }
    /**
     * @description  设置规则区间单价的表单配置， conf：从render里传入的数据
     * @param {any} conf   {type: "editRule", obj: obj, parentObj: parent, idx: [...lvKeys, i],  parentIdx: lvKeys}
     * @returns {any}
     */
    function getWeightRuleFormAttrs(
      conf: EditFormType,
    ): Partial<QuickFormPropsType> {
      return {
        formProps: {
          labelWidth: '130px',
        },
        onSubmit: (
          v: WeightRule,
          fetchData: Record<string, any>,
          btnObj: PowerfulBtnPropsType,
          btnState: BtnStateType,
        ) => {
          btnState.dialogVisible = false
          const setVal: WeightRule = filterSubmitData(v, conf)
          if (conf.type == 'addRule') {
            addRuleFunc(conf, setVal)
          }
          else if (conf.type == 'moveRule') {
            moveRuleFunc(conf, v)
          }
          else {
            // 编辑

            const findItem: WeightRule | WeightRule[] = findItemByidxArr(
              conf.parentIdx,
            )
            const setItemList: WeightRule[] = conf.parentObj
              ? (findItem as WeightRule).childRule || []
              : (findItem as WeightRule[])

            setItemList[conf.idx[conf.idx.length - 1]] = setVal
          }
          Bus.$emit('baseRateTableUpdateRender')
          //  that.$forceUpdate && that.$forceUpdate(); // 强制刷新

          nextTick(() => {
            ctx.emit('rateTableValueChange', dataState.weightRule)
            updateSort(dataState.weightRule)
            props.onDataChange(dataState.weightRule)
            ctx.emit('update:modelValue', dataState.weightRule)
            refs.table && refs.table.doLayout && refs.table.doLayout()
          })
        },

        renderDataFilter: (
          renderData: FormRenderItemConfType<any>[],
          value: WeightRule,
          formObj: QuickFormType,
        ) => {
          //  debugger;
          if (dataState.renderDataMap.ruleType)
            dataState.renderDataMap.ruleType.disabled = props.ruleTypeDisabled
          const { renderDataMap } = dataState
          let resRenderData: any[] = [
            {
              type: 'slot',
              render: (): VNode => {
                return (
                  <el-alert
                    style="margin-bottom:15px;"
                    title="温馨提示:最大值设置为0则为无穷大,一级规则不填单价才能增加子规则"
                    type="warning"
                    closable={false}
                  >
                  </el-alert>
                )
              },
            },
            renderDataMap.ruleType,
            renderDataMap.startInterval,
            renderDataMap.minWeight,
            renderDataMap.endInterval,
            renderDataMap.maxWeight,
            renderDataMap.price,
            renderDataMap.priceType,
          ]
          if (conf.type == 'moveRule') {
            resRenderData = [
              {
                type: 'treeextend',
                name: 'treeIndexT',
                style: 'width:100%',
                expandOnClickNode: false,
                defaultExpandAll: true,
                nodeKey: 'value',
                events: {
                  'node-click': (v: any) => {
                    console.log(v)
                    formObj.formDataState.formValue.treeIndex = v.value
                  },
                },

                multiple: false,
                data: makeRulesToTreeIndex(conf),
                layoutCol: { sm: 24 },
              },
            ]
          }
          resRenderData = props.ruleFormRenderDataFilter(
            resRenderData as FormRenderItemConfType<any>[],
            conf,
            ctx,
            formObj,
          )
          return resRenderData
        },
      }
    }
    /**
     * @description 移动node
     * @param {any} conf
     * @returns {any}
     */
    function makeRulesToTreeIndex(conf: EditFormType): Option[] {
      return [
        {
          label: '顶级',
          value: 'top',
          children: filterRuleIndexData(
            cloneDeep(dataState.weightRule),
            conf.idx,
          ),
        },
      ]
    }
    /**
     * @description
     * @param {any} rules
     * @param {any} filterKeys = []
     * @param {any} lv = []
     * @returns {any}
     */
    function filterRuleIndexData(
      rules: WeightRuleTreeNode[],
      filterKeys: number[] = [],
      lv: number[] = [],
    ): WeightRuleTreeNode[] {
      const res: WeightRuleTreeNode[] = []
      rules.map((o: WeightRuleTreeNode, i: number) => {
        o.label = setLabel(o, i, rules, false) as string
        const setLv = [...lv, i]
        o.value = setLv.join('-')
        o.id = setLv.join('-')
        if (o.childRule && o.childRule.length) {
          o.children = filterRuleIndexData(o.childRule, filterKeys, setLv)
        }
        if (
          o.value.indexOf(filterKeys.join('-')) != 0
          && ((o.childRule && o.childRule.length) || !o.price)
          && !o.stencilId
        ) {
          res.push(o)
        }
      })
      return res
    }
    function setInitRuleForm(res: WeightRule, conf: EditFormType): WeightRule {
      return props.setAddRuleFormInitValueFilter(res, conf)
    }

    function updateSort(weightRules: WeightRule[]): void {
      weightRules.map((o: WeightRule, idx: number) => {
        weightRules[idx].sort = idx
        if (o.childRule && o.childRule.length) {
          updateSort(o.childRule)
        }
      })
    }
    /**
     * @description
     * @param {any} list
     * @param {any} parent = null
     * @param {any} lvKeys = []
     * @returns {any}
     */
    function treeTableColRender(
      list: WeightRule[] = [],
      parent: WeightRule | null = null,
      lvKeys: number[] = [],
    ): VNode[] {
      return list.map((obj: WeightRule, i: number): VNode => {
        const setLabelText: string = setLabel(obj, i, list, false) as string
        return h(
          ElTableColumn,
          {
            level: 1,
            key: setLabelText + i + lvKeys.join(','),
            minWidth: '210',
            label: setLabelText,
          },
          {
            header: () => [
              h(
                ElPopover,
                {
                  disabled: props.disabled,
                  title: '操作规则',
                  width: '200',
                  trigger: 'click',
                },
                {
                  default: () => [
                    <el-button-group>
                      <el-tooltip effect="dark" content="编辑规则">
                        <PowerfulBtn
                          type="form"
                          no-wrap="true"
                          formFetchToSetValueFilter={() =>
                            rowToEditFormValue([...lvKeys, i], {
                              type: 'editRule',
                              obj,
                              parentObj: parent,
                              idx: [...lvKeys, i],
                              parentIdx: lvKeys,
                            })}
                          dialog-props={{ title: '编辑规则', width: '800px' }}
                          to-set-quickform-props={getWeightRuleFormAttrs({
                            type: 'editRule',
                            obj,
                            parentObj: parent,
                            idx: [...lvKeys, i],
                            parentIdx: lvKeys,
                          })}
                        >
                          <el-icon>
                            <Edit />
                          </el-icon>
                        </PowerfulBtn>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="删除规则">
                        <el-button onclick={() => deleteRuleRow(lvKeys, i)}>
                          <el-icon>
                            <Delete />
                          </el-icon>
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="只删除这一区间">
                        <el-button onclick={() => deleteNowRuleRow(lvKeys, i)}>
                          <el-icon>
                            <Remove />
                          </el-icon>
                        </el-button>
                      </el-tooltip>
                      {obj.price
                        ? null
                        : (
                            <el-tooltip effect="dark" content="添加子规则">
                              <PowerfulBtn
                                type="form"
                                no-wrap="true"
                                formFetchToSetValueFilter={() =>
                                  setInitRuleForm(
                                    initWeightRuleData({ ruleType: '0' }),
                                    {
                                      type: 'addRule',
                                      obj: initWeightRuleData({}),
                                      parentObj: obj,
                                      idx: [...lvKeys, i],
                                      parentIdx: lvKeys,
                                    },
                                  )}
                                dialog-props={{
                                  title: '添加子规则',
                                  width: '800px',
                                }}
                                to-set-quickform-props={getWeightRuleFormAttrs({
                                  type: 'addRule',
                                  obj: initWeightRuleData({}),
                                  parentObj: obj,
                                  idx: [...lvKeys, i],
                                  parentIdx: lvKeys,
                                })}
                              >
                                <el-icon>
                                  <Plus />
                                </el-icon>
                              </PowerfulBtn>
                            </el-tooltip>
                          )}
                      <el-tooltip effect="dark" content="移动规则">
                        <PowerfulBtn
                          type="form"
                          no-wrap="true"
                          formFetchToSetValueFilter={() =>
                            setInitRuleForm(
                              initWeightRuleData({ ruleType: '0' }),
                              {
                                type: 'moveRule',
                                isUpParent: true,
                                obj: initWeightRuleData({}),
                                parentObj: obj,
                                idx: [...lvKeys, i],
                                parentIdx: lvKeys,
                              },
                            )}
                          dialog-attrs={{ title: '移动规则', width: '800px' }}
                          to-set-quickform-attr={getWeightRuleFormAttrs({
                            type: 'moveRule',
                            isUpParent: true,
                            obj: initWeightRuleData({}),
                            parentObj: obj,
                            idx: [...lvKeys, i],
                            parentIdx: lvKeys,
                          })}
                        >
                          <el-icon>
                            <Place />
                          </el-icon>
                        </PowerfulBtn>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="往前排序">
                        <el-button onclick={() => moveRule(lvKeys, i, -1)}>
                          <el-icon>
                            <ArrowLeft />
                          </el-icon>
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="往后排序">
                        <el-button onclick={() => moveRule(lvKeys, i, 1)}>
                          <el-icon>
                            <ArrowRight />
                          </el-icon>
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="复制规则">
                        <el-button onclick={() => copyRuleRow(lvKeys, i)}>
                          <el-icon>
                            <DocumentCopy />
                          </el-icon>
                        </el-button>
                      </el-tooltip>
                    </el-button-group>,
                  ],
                  reference: () => [
                    <span style="cursor:pointer;white-space:nowrap;">
                      {setLabelText}
                      <el-icon size={14}>
                        {!props.disabled ? <ArrowDown /> : ''}
                      </el-icon>
                    </span>,
                  ],
                },
              ),
            ],
            default: () => [
              obj.childRule && obj.childRule.length
                ? treeTableColRender(obj.childRule, obj, [...lvKeys, i])
                : null,
              <span>
                {obj.price || props.showZeroPrice ? `￥${obj.price || 0}` : ''}
              </span>,
            ],
          },
        )
      })
    }
    return {
      dataState,
      initWeightRuleData,
      treeTableColRender,
      setAddRuleFormInitValue,
      getWeightRuleFormAttrs,
      updateSort,
    }
  },

  render(
    _ctx: ComponentPublicInstance<RateTablePropsType, RateTableType>,
  ): any {
    return (
      <el-table
        ref="table"
        border
        data={[{ id: _ctx.dataState.tableRenderKey }]}
      >
        {_ctx.$slots.prevHeader
        && _ctx.$slots.prevHeader({ weightRule: _ctx.dataState.weightRule })}
        {_ctx.treeTableColRender(_ctx.dataState.weightRule, null, [])}
        {_ctx.$slots.afterHeader
        && _ctx.$slots.afterHeader({ weightRule: _ctx.dataState.weightRule })}
        {_ctx.$props.disabled
          ? null
          : (
              <el-table-column
                key="操作"
                width={_ctx.$props.buttonGroupWidth}
                label="操作"
              >
                <el-button-group>
                  <el-tooltip effect="dark" content="添加规则">
                    <PowerfulBtn
                      type="form"
                      no-wrap={true}
                      dialog-props={{ title: '添加规则', width: '800px' }}
                      formFetchToSetValueFilter={() =>
                        _ctx.setAddRuleFormInitValue(_ctx.dataState.weightRule, {
                          type: 'addRule',
                          obj: _ctx.initWeightRuleData({}),
                          parentObj: null,
                          idx: [],
                          parentIdx: [],
                        })}
                      toSetQuickformProps={_ctx.getWeightRuleFormAttrs({
                        type: 'addRule',
                        obj: _ctx.initWeightRuleData({}),
                        parentObj: null,
                        idx: [],
                        parentIdx: [],
                      })}
                    >
                      <el-icon size={14}>
                        <Plus />
                      </el-icon>
                    </PowerfulBtn>
                  </el-tooltip>
                  {_ctx.$slots.buttonGroup
                  && _ctx.$slots.buttonGroup({
                    weightRule: _ctx.dataState.weightRule,
                  })}
                </el-button-group>
              </el-table-column>
            )}
      </el-table>
    )
  },
})
</script>
